export const DateFormatter = {
  
  toShortDate: (date) => {
    return new Intl.DateTimeFormat('en-US', {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date(date));
  },
  toShortDate2: (date, isYear2digit = false) => {
    return date? new Intl.DateTimeFormat('en-US', {
      year: isYear2digit ? '2-digit' : 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date(date)).replace(/\//g, '-'):'';
  },
  toLongDateTime: (date, isYear2digit = false, showSeconds = true, is12Hour = true) => {
    if (!date) return '';

    const options = {
      year: isYear2digit ? '2-digit' : 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: is12Hour ? true : false
    };

    if (showSeconds) { options.second = '2-digit'; }
    return new Intl.DateTimeFormat('en-US', options).format(new Date(date)).replace(',', '').replace(/\//g, '-');
  },
  toLongDateTime2: (date) => {
    return date? new Intl.DateTimeFormat('en-US', {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).format(new Date(date)).replace(/\//g, '-'):'';
  }
};